// extracted by mini-css-extract-plugin
module.exports = {"logoPreview":"EventVenueInfo_logoPreview__3YjPY"};